import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import AppointmentDetails from "../../components/Appointments/AppointmentDetails";

const AppointmentsShow = ({appointment, backLink}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('cooperations.contract')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('default.nav.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    icon: 'edit',
                    text: i18n.get('cooperations.edit'),
                    href: `/appointments/${appointment.id}/edit`,
                }
            ]}
        />

                <AppointmentDetails appointment={appointment}/>
    </Layout>
);

export default AppointmentsShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/notes/Show.jsx